import { WidgetMaker } from './types/widget-maker';
import { ParseJoiValidateResponse } from '../../utils';

export const getErrorMessage = (
  errors: ParseJoiValidateResponse<WidgetMaker>,
  baseKey: keyof WidgetMaker,
  fieldKey?: string,
  index?: number
) => {
  const basePath =
    index !== undefined ? `widgetMaker.${baseKey}.${index}` : `widgetMaker.${baseKey}`;
  const errorKey = fieldKey ? `${basePath}.${fieldKey}` : basePath;

  return errors?.[errorKey]?.message || '';
};
